import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Page title
document.title = 'Inteligencia Social Estratégica';
// Meta tags helper
const setMeta = (property: string, content: string) => {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
const setMetaName = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
const TITLE = 'Inteligencia Social Estratégica';
const DESC = 'El sistema para detectar engaños, dominar conversaciones y ganar respeto instantáneo.';
const IMG = 'https://cdn.magicpatterns.com/uploads/jq4oCouCmrcu5LgrGg5Vut/ChatGPT_Image_23_feb_2026,_13_39_58.png';
setMeta('og:title', TITLE);
setMeta('og:description', DESC);
setMeta('og:image', IMG);
setMeta('og:type', 'website');
setMetaName('twitter:title', TITLE);
setMetaName('twitter:description', DESC);
setMetaName('twitter:card', 'summary_large_image');
setMetaName('twitter:image', IMG)
// Meta Pixel
;
(function () {
  const f = window as any;
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode!.insertBefore(t, s);
})();
const fbq = (window as any).fbq;
fbq('init', '1927478928649366');
fbq('track', 'PageView');
render(<App data-id="element-328" />, document.getElementById('root'));